export default __webpack_public_path__ + "static/media/loopstudios.51cbdf72.png";